import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';

@Injectable({
  providedIn: 'root'
})
export class ProviderCertificationDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  public async downloadAndSaveDocumentFileAsync(id: number | string): Promise<any> {
    try {
      var fileResponse = await this.downloadDocumentFileBlobAsync(id);

      fileResponse.save();
    }
    catch (e) {

    }
  }

  public uploadDocumentFileAsync(file: File, id: number | string): Promise<any> {
    return this.httpClient.postFileAsync('ProviderCertifications/UploadFile', file, id);
  }

  public deleteDocumentAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ProviderCertifications/Delete', id, timeout);
  }

  private downloadDocumentFileBlobAsync(id: number | string): Promise<FileResponse> {
    return this.httpClient.getFileAsync(`ProviderCertifications/Download?id=${id.toString()}`);
  }
}
